export default __webpack_public_path__ + "media/images/front/municipality_collaboration/plane-10a0fc9779c8131a49eb6257e641434d.png";